export default "__VITE_ASSET__DBUG$c2B__"